type Props = {
    title?: string
    subtitle?: string
}
const NoResults = ({
    title = 'No se encuentran resultados.',
    subtitle = 'Intentá cambiar los parámetros de búsqueda.',
}: Props) => {
    return (
        <div className="flex gap-1 md:gap-0">
            <img
                alt="No Results"
                src="/no-results.svg"
            />
            <div className="flex flex-col gap-1 md:gap-0 md:p-4 text-[#5A607F]">
                <span className="font-bold text-sm md:text-base">{title}</span>
                <span className="font-medium text-sm md:text-base">{subtitle}</span>
            </div>
        </div>
    )
}

export default NoResults
